<template>
        <div :class="[classes(), 'hanzo-hairline']" @click="onClick">
        <h-icon
            :class="[classes('icon'), this.iconClass]"
            :type="icon"
            :info="info"
        />
        <slot>{{text}}</slot>
    </div>
</template>
<script>
import hIcon from '../../icon/index';
import { useBEM } from '../../../common/utils/classnames';
let classnames = useBEM( 'hanzo-goods-action-icon' );
export default {
    name: 'h-goods-action-icon',
    components: {
        hIcon
    },
    props: {
        icon: String,
        text: String,
        info: String | Number,
        iconClass: String
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        },
        onClick( e ) {
            this.$emit( 'click', e );
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
